import React from 'react';
import styled from '@emotion/styled';
import OtherBankInstallmentRadio from '../radio/OtherBankInstallmentRadio';
import OtherBankAdvanceReceivedRate from '../select/OtherBankAdvanceReceivedRate';
import OtherBankAdvanceReceivedFullRate from './OtherBankAdvanceReceivedFullRate';

const Base = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: auto auto 1fr;

    span:last-of-type {
      justify-self: end;
    }
  }
`;

/**
 *  타금융사 할부조건 선수율 컨텐츠 컴포넌트
 *  */
function OtherBankAdvanceReceivedRateContents(): JSX.Element {
  return (
    <Base>
      <OtherBankInstallmentRadio type='advanceReceivedRate' text='선수율' />
      <OtherBankAdvanceReceivedRate />
      <OtherBankAdvanceReceivedFullRate />
    </Base>
  );
}

export default OtherBankAdvanceReceivedRateContents;
